module.exports = __webpack_public_path__ + "static/lift-screen1-9f761a289c5f660cd2a37fb3e5677158.jpg";